module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_7.fe3629c1.jpg";